import moment from "moment";

export const handleActiveFilter = (mainData, filterOptions) => {
  let findAnyCustomer = mainData.reduce((acc, c) => {
    const {
      startCreateDate,
      endCreateDate,
      mikrotik,
      mikrotikPackage,
      hotspotPackage,
      area,
      subArea,
      poleBox,
      status,
      paymentStatus,
      reseller,
      bandwidthReseller,
      createdBy,
      collectedBy,
      allCustomer,
      billDayLeft,
      startDate,
      endDate,
      startPromiseDate,
      endPromiseDate,
      changeCustomer,
      userType,
      billType,
      billingType,
      medium,
      action,
      connectionStatus,
    } = filterOptions;

    // make date object
    const createDate = new Date(
      moment(c.createdAt).format("YYYY-MM-DD hh:mm a")
    );

    const billingCycle = new Date(
      moment(c.billingCycle).format("YYYY-MM-DD hh:mm a")
    );

    const promiseDate = new Date(
      moment(c.promiseDate).format("YYYY-MM-DD hh:mm a")
    );

    const billingStartData = new Date(
      moment(startDate).format("YYYY-MM-DD hh:mm a")
    );
    const billingEndData = new Date(
      moment(endDate).format("YYYY-MM-DD hh:mm a")
    );

    const promiseStartData = new Date(
      moment(startPromiseDate).format("YYYY-MM-DD hh:mm a")
    );
    const promiseEndData = new Date(
      moment(endPromiseDate).format("YYYY-MM-DD hh:mm a")
    );

    const monthCreateDateStart = new Date(
      moment(startCreateDate).format("YYYY-MM-DD hh:mm a")
    );

    const monthCreateDateEnd = new Date(
      moment(endCreateDate).format("YYYY-MM-DD hh:mm a")
    );

    const dayLeft = Math.round(
      moment(c.billingCycle).diff(moment(), "hours") / 24
    );

    // make connection status true or false
    let autoConnection;
    if (changeCustomer === "true") {
      autoConnection = false;
    } else if (changeCustomer === "false") {
      autoConnection = true;
    }

    // make possible conditions objects if the filter value not selected thats return true
    //if filter value exist then compare
    const conditions = {
      createDate:
        startCreateDate && endCreateDate
          ? monthCreateDateStart <= createDate &&
            monthCreateDateEnd >= createDate
          : true,
      mikrotik: mikrotik ? c.mikrotik === mikrotik : true,
      package: mikrotikPackage ? c.mikrotikPackage === mikrotikPackage : true,
      hotspotPackage: hotspotPackage
        ? c.hotspotPackage === hotspotPackage
        : true,
      area: area ? c.area === area : true,
      subArea: subArea ? c.subArea === subArea : true,
      poleBox: poleBox ? c.poleBox === poleBox : true,
      status: status ? c.status === status : true,
      paid: paymentStatus ? c.paymentStatus === "paid" : true,
      unpaid: paymentStatus
        ? c.paymentStatus === "unpaid" && c.monthlyFee !== 0
        : true,
      free: paymentStatus ? c.monthlyFee === 0 : true,
      partial: paymentStatus
        ? c.paymentStatus === "unpaid" &&
          c.monthlyFee > c.balance &&
          c.balance > 0
        : true,
      advance: paymentStatus
        ? c.monthlyFee <= c.balance && c.monthlyFee > 0
        : true,
      overDue: paymentStatus
        ? c.paymentStatus === "unpaid" && c.balance < 0
        : true,
      reseller: reseller ? c.reseller === reseller : true,
      bandwidthReseller: bandwidthReseller
        ? c.reseller === bandwidthReseller
        : true,
      createdBy: createdBy ? c.createdBy === createdBy : true,
      collectedBy: collectedBy ? c.collectorId === collectedBy : true,
      freeUser: allCustomer ? c.monthlyFee === 0 : true,
      nonFreeUser: allCustomer ? c.monthlyFee > 0 : true,
      prepaid: allCustomer ? c.customerBillingType === "prepaid" : true,
      postpaid: allCustomer ? c.customerBillingType === "postpaid" : true,
      billDayLeft: billDayLeft ? dayLeft === Number(billDayLeft) : true,
      billingDate:
        startDate && endDate
          ? billingStartData <= billingCycle && billingEndData >= billingCycle
          : true,
      promiseDate:
        startPromiseDate && endPromiseDate
          ? promiseStartData <= promiseDate && promiseEndData >= promiseDate
          : true,
      promiseDateChange:
        changeCustomer === "promiseDate"
          ? billingCycle < promiseDate || billingCycle > promiseDate
          : true,
      autoDisable: changeCustomer ? c.autoDisable !== autoConnection : true,
      userType: userType ? c.userType === userType : true,
      billType: billType ? c.billType === billType : true,
      billingType: billingType ? c.billingType === billingType : true,
      medium: medium
        ? "onlinePayment" === medium
          ? ["sslcommerz", "uddoktapay", "sslpay", "bKashPG"].includes(c.medium)
          : c.medium === medium
        : true,
      action: action ? c.action === action : true,
      online: connectionStatus === "online" ? c.running === true : true,
      offline: connectionStatus === "offline" ? c.running !== true : true,
    };

    //check if condition pass got for next step or is fail stop operation
    //if specific filter option value not exist it will return true

    let isPass = false;

    isPass = conditions["createDate"];
    if (!isPass) return acc;

    isPass = conditions["mikrotik"];
    if (!isPass) return acc;

    isPass = conditions["package"];
    if (!isPass) return acc;

    isPass = conditions["hotspotPackage"];
    if (!isPass) return acc;

    isPass = conditions["area"];
    if (!isPass) return acc;

    isPass = conditions["poleBox"];
    if (!isPass) return acc;

    isPass = conditions["subArea"];
    if (!isPass) return acc;

    isPass = conditions["status"];
    if (!isPass) return acc;

    if (paymentStatus) {
      isPass = conditions[paymentStatus];
      if (!isPass) return acc;
    }

    isPass = conditions["reseller"];
    if (!isPass) return acc;

    isPass = conditions["bandwidthReseller"];
    if (!isPass) return acc;

    isPass = conditions["createdBy"];
    if (!isPass) return acc;

    isPass = conditions["collectedBy"];
    if (!isPass) return acc;

    isPass = conditions["billType"];
    if (!isPass) return acc;

    isPass = conditions["billingType"];
    if (!isPass) return acc;

    isPass = conditions["medium"];
    if (!isPass) return acc;

    if (allCustomer) {
      isPass = conditions[allCustomer];
      if (!isPass) return acc;
    }

    isPass = conditions["billDayLeft"];
    if (!isPass) return acc;

    isPass = conditions["billingDate"];
    if (!isPass) return acc;

    isPass = conditions["promiseDate"];
    if (!isPass) return acc;

    isPass = conditions["promiseDateChange"];
    if (!isPass) return acc;

    isPass = conditions["autoDisable"];
    if (!isPass) return acc;

    isPass = conditions["userType"];
    if (!isPass) return acc;

    isPass = conditions["action"];
    if (!isPass) return acc;

    if (connectionStatus) {
      isPass = conditions[connectionStatus];
      if (!isPass) return acc;
    }

    if (isPass) acc.push(c);

    return acc;
  }, []);

  // set filter customer in customer state
  return findAnyCustomer;
};
